import React from 'react';

import SelectedOptions from './selectedoptions';
import Footer from './footer';

import '@styles/customise/sidebar.scss';

const Sidebar: React.FC = () => {
  return (
    <div className="customise-sidebar">
      <div className="customise-sidebar__content">
        <SelectedOptions />
        <Footer />
      </div>
    </div>
  );
};

export default Sidebar;
